import { Helper } from "./../../shared/helper";
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  HostListener,
  OnDestroy
} from "@angular/core";
import { Kpi } from "app/features/kpi/kpi";
import { DataCollectionService } from "app/shared/services/data-collection.service";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { LoaderService } from "app/shared";
import { ThounsandSeparatorPipe } from "app/shared/pipes/thounsand-separator.pipe";
import { RoundNumberPipe } from "app/shared/pipes/round-number.pipe";
import { DashSelectionService } from "app/shared/services/dash-selection.service";
import { Observable, Subscription } from "rxjs";
import { DataInteraction } from "app/shared/data-interaction";
import { isNullOrUndefined } from "util";
import { MULTICITY_PARAM, COMPARE_KPI } from "app/shared";
import * as uikit from "uikit";

@Component({
  selector: "app-kpi",
  templateUrl: "./kpi.component.html",
  styleUrls: ["./kpi.component.scss"]
})
export class KpiComponent implements OnChanges, OnDestroy {
  @Input() dataFilters: DataInteraction;
  @Input() configData;
  @Input() dashToDisplay;

  selectedDashboard: string;
  selectedDashboard$: Observable<string>;
  selectedDahsboardSubscription?: Subscription;
  private title = "KPIs";
  private titleData;
  private _kpis = [];
  private selectedCity: String = "Bovernier";
  private config_kpis;
  private kpis_from_config_file;
  private unit_kpi;
  private year;
  private multiCityParam: String;
  private compareKpis = COMPARE_KPI;
  private screenWidth: number = window.innerWidth;
  private dashboard_tab_description: boolean = false;

  constructor(
    private dataCollectionService: DataCollectionService,
    private helper: Helper,
    private loaderService: LoaderService,
    private dashSelectionService: DashSelectionService,
    private translateService: TranslateService
  ) {
    this.selectedDashboard$ = dashSelectionService.getSelectedDashboard();
    this.selectedDahsboardSubscription = this.selectedDashboard$.subscribe(
      selectedDashboard => {
        this.selectedDashboard = selectedDashboard;
      }
    );
    this.multiCityParam = MULTICITY_PARAM;
  }
  get kpis() {
    return this._kpis;
  }

  ngOnDestroy(): void {
    // remove subscriptions
    this.selectedDahsboardSubscription.unsubscribe();
  }

  ngOnChanges(changes) {
    // when data filters changes and has a defined value
    if (changes.dataFilters && changes.dataFilters.currentValue) {
      // only when energy service is defined
      if (changes.dataFilters.currentValue.energy_service) {
        this.refreshDashboard();
      }
    }
  }

  refreshDashboard() {
    this.dataCollectionService.getConfigFile().then(data => {
      if (this.configData && 'dashboardTabDescription' in this.configData.dashboards[this.selectedDashboard]){
        this.dashboard_tab_description = this.configData.dashboards[this.selectedDashboard]['dashboardTabDescription'];
      }
      this.kpis_from_config_file =
        data["dashboards"][this.selectedDashboard]["kpis"];
      this.update();
    });
  }

  update() {
    if (this.dataFilters) {
      const city = this.dataFilters.cities.filter(x => x.selected === true);
      if (
        city.length !== 0 &&
        !this.helper.isNullOrUndefined(this.dataFilters.year)
      ) {
        this.filterKpisToDisplay();
        if (
          city[0].name !== this.selectedCity ||
          this.year != this.dataFilters.year ||
          this.config_kpis
        ) {
          this.year = this.dataFilters.year;
          this.selectedCity = city[0].translate;
          var arrayKpisStringList = "";
          var arrayKpisStringList_evolAbs = "";
          var arrayKpisStringList_evolPct = "";
          var i;
          for (i = 0; i < this.config_kpis.length; i++) {
            arrayKpisStringList += `${this.config_kpis[i]["id"]},`;
            if (this.config_kpis[i]["type"] === 'evolution_abs'){
              arrayKpisStringList_evolAbs += `${this.config_kpis[i]["id"]},`;
            }
            if (this.config_kpis[i]["type"] === 'evolution_pct'){
              arrayKpisStringList_evolPct += `${this.config_kpis[i]["id"]},`;
            }
          }
          // arrayKpisStringList += this.config_kpis[i]["id"];
          //const promise = this.dataCollectionService.getKPI(city[0].objectId, this.year.objectId, arrayKpisStringList).toPromise();
          this.dataCollectionService
            .getKPI(city[0].objectId, this.year.objectId, arrayKpisStringList, arrayKpisStringList_evolAbs, arrayKpisStringList_evolPct)
            .subscribe(
              data => {
                this._kpis = data.results;
                var i;
                var kpis_keys = [];
                var config_kpis_keys = [];
                for (var item in this._kpis) {
                  kpis_keys.push(this._kpis[item]["name"]);
                }
                for (var item in this.config_kpis) {
                  config_kpis_keys.push(this.config_kpis[item]["id"]);
                }
                if (
                  kpis_keys.length === config_kpis_keys.length &&
                  kpis_keys.every(
                    (val, index) => val === config_kpis_keys[index]
                  )
                ) {
                  for (i = 0; i < this.config_kpis.length; i++) {
                    // Patch: if unit is not simple to display or is not convertable
                    let unit_to_display = "-";
                    if (this.config_kpis[i].unit !== "-") {
                      unit_to_display = this.helper.getUnitInfo(
                        this.config_kpis[i].unit
                      );
                      this.unit_kpi = unit_to_display["translate_unit"];
                      this.unit_kpi = this.unit_kpi.substring(
                        this.unit_kpi.indexOf(".") + 1
                      );
                    }
                    // Find index of kpi in result having same name than name from config
                    let kpi_index_in_result = this._kpis
                      .map(function(e) {
                        return e.name;
                      })
                      .indexOf(this.config_kpis[i].id);
                    var factor_to_convert_units = 1;
                    if (
                      this._kpis[kpi_index_in_result].unit.toLowerCase() !=
                      this.config_kpis[i].unit
                    ) {
                      //error TS2367: This condition will always return 'true' since the types 'string' and '(object: any) => boolean' have no overlap.
                      //if (unit_to_display != isNullOrUndefined){
                      if (unit_to_display != undefined) {
                        factor_to_convert_units =
                          unit_to_display["convert_factor_from"][
                            this._kpis[kpi_index_in_result].unit.toLowerCase()
                          ];
                      } else {
                        this._kpis[i].unit = "unit_error";
                        continue;
                      }
                    }
                    this._kpis[i].value *= factor_to_convert_units;
                    // Patch: if unit is not simple to display or is not convertable
                    if (
                      this.config_kpis[i].unit !== "-" &&
                      this.config_kpis[i].unit !== "chf"
                    ) {
                      this._kpis[i].unit = this.unit_kpi; //unit_to_display["translate_unit"];
                      [
                        this._kpis[i].value,
                        this._kpis[i].unit
                      ] = this.helper.convertTooBigValue(
                        this._kpis[i].value,
                        this._kpis[i].unit
                      );
                    }
                  }
                  // this.loaderService.displayMainLoader(false)
                  // this.setTitle('DASHBOARD.KPI.TITLE', { commune: this.selectedCity, date: this.dataFilters.year['name'] })
                }
              },
              error => {
                this._kpis = null;
                // Default title
                this.setTitle("DASHBOARD.KPI.DEFAUTTITLE", {});
              }
            );
        }
      }
    }
  }
  getOrderedConfig() {
    if (!this.helper.isNullOrUndefined(this.config_kpis)) {
      return this.helper.getOrderedDictByOrderName(this.config_kpis);
    }
    return [];
  }
  getKpiById(id) {
    var val = this._kpis.filter(x => x.name === id)[0];
    return val;
  }
  getKpiTooltipTranslated(id) {
    uikit
      .tooltip("#kpi_" + id, {
        title: this.translateService.instant(`DASHBOARD.KPI.${id}.INFO`),
        pos: "right"
      })
      .show();
  }
  setTitle(title, data) {
    this.title = title;
    this.titleData = data;
  }
  filterKpisToDisplay() {
    let listOfKpisToUpdate = [];
    let updateKpisWithNewFilter = false;
    var i;
    for (i = 0; i < this.kpis_from_config_file.length; i++) {
      let checkIfKpi = true;
      for (const item in this.kpis_from_config_file[i]["filter-options"]) {
        if (
          this.kpis_from_config_file[i]["filter-options"][item] !=
          this.dataFilters[item]
        ) {
          checkIfKpi = false;
          break;
        }
      }
      if (checkIfKpi) {
        listOfKpisToUpdate.push(this.kpis_from_config_file[i]);
        updateKpisWithNewFilter = true;
      }
    }
    this.config_kpis = listOfKpisToUpdate;

    return updateKpisWithNewFilter;
  }

  // return the class uk-width-<column>-<width> (from ui-kit)
  // column and width are adapted to screen width
  getUkWidth(column, width) {
    if (this.screenWidth < 1050) {
      // for small screen, stack everything in one column
      column = 1;
      width = 1;
    } else if (this.screenWidth < 1400) {
      // for medium screen, the maximum number of column is set to 2
      width = width > 2 ? 2 : width;
    }
    // for large screen, keep the config values
    return `uk-width-${column}-${width}`;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event?) {
    // track screen width
    this.screenWidth = window.innerWidth;
  }
}
